exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultado[data-v-05a51ed0] {\n  border: 0;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;\n}\n.resultado svg[data-v-05a51ed0] {\n  display: block;\n}\n.resultado > .fa-picture-o[data-v-05a51ed0] {\n  position: absolute;\n  top: 55px;\n  font-size: 130px;\n  left: 45px;\n  color: #959595;\n}", ""]);

// exports
